const deriveHref = (dataset = {}) => {
  if (!dataset) return '';
  if (dataset.mentionHref) return dataset.mentionHref;

  const slug = dataset.mentionSlug;
  if (!slug) return '';

  const type = dataset.mentionType || 'user';
  if (type === 'grave') return `/graves/${slug}`;
  return `/members/${slug}`;
};

const buildClassName = (existingClassName = '', type = 'user') => {
  const classes = new Set(
    existingClassName
      .split(/\s+/)
      .map((value) => value.trim())
      .filter(Boolean),
  );

  classes.add('spark-mention');
  if (type === 'grave') classes.add('spark-mention--grave');

  return Array.from(classes).join(' ');
};

export const enhanceMentions = (root) => {
  if (typeof window === 'undefined' || !root) return;

  const nodes = root.querySelectorAll('[data-mention-id]');
  nodes.forEach((node) => {
    const dataset = node.dataset || {};
    const type = dataset.mentionType || 'user';
    const href = deriveHref(dataset);

    if (!href) {
      node.className = buildClassName(node.className, type);
      return;
    }

    const className = buildClassName(node.className, type);

    if (node.tagName.toLowerCase() === 'a') {
      node.className = className;
      node.setAttribute('href', href);
      node.setAttribute('title', dataset.mentionName || dataset.mentionSlug || node.textContent || '');
      return;
    }

    const anchor = document.createElement('a');
    anchor.className = className;
    anchor.textContent = node.textContent;
    anchor.setAttribute('href', href);
    anchor.setAttribute('title', dataset.mentionName || dataset.mentionSlug || node.textContent || '');

    if (dataset.mentionId) anchor.dataset.mentionId = dataset.mentionId;
    if (dataset.mentionType) anchor.dataset.mentionType = dataset.mentionType;
    if (dataset.mentionName) anchor.dataset.mentionName = dataset.mentionName;
    if (dataset.mentionSlug) anchor.dataset.mentionSlug = dataset.mentionSlug;
    if (dataset.mentionHref || href) anchor.dataset.mentionHref = dataset.mentionHref || href;

    node.replaceWith(anchor);
  });
};

export default enhanceMentions;
